
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Entryregister.css";
import Header from "../Header/Header";
import Footer from "../Header/Footer";
import axios from "axios";

const Entryregister = () => {
  const [aadhaarDigits, setAadhaarDigits] = useState(Array(12).fill(""));
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const [otpPopup, setOtpPopup] = useState(false);
  const [clientId, setClientId] = useState("");
  // const [basicDataPopup,setBasicDataPopup] =useState(false)
  // const [data,setData]=useState('')
  const navigate = useNavigate();

  const getAadhaarNumber = () => aadhaarDigits.join("");
  const getAadhaarOtp = () => otpDigits.join("");

  const handleAadhaarChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const updatedDigits = [...aadhaarDigits];
      updatedDigits[index] = value;
      setAadhaarDigits(updatedDigits);

      if (value && index < 11) {
        const nextInput = document.getElementById(`aadhaar-box-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleOtpChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const updatedDigits = [...otpDigits];
      updatedDigits[index] = value;
      setOtpDigits(updatedDigits);

      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-box-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const aadhaarNumber = getAadhaarNumber();
    const apikey = process.env.REACT_APP_API_KEY;

    try {
      const response = await axios.post("https://matrimony.bugchat.in/api/aadhaarverify", {
        aadhaarNumber,
        apikey,
      });
      console.log(response.data.message)
      console.log(response.data.otpResponse.client_id)
      console.log(response.data)
      if (response.data.message === "OTP sent successfully") {
        setOtpPopup(true);
        setClientId(response.data.otpResponse.client_id);
      }
       if (response.data.message === "Already Matrimony User") {
       alert('Already Matrimony User')
       navigate('/login')
      }
    } catch (error) {
      console.error("Error submitting Aadhaar:", error);
    }
  };

  const handleVerifyOtp = async () => {
    const otp = getAadhaarOtp();
    const apikey = process.env.REACT_APP_API_KEY;
       const aadhaarNumber = getAadhaarNumber();
     console.log(clientId)
    try {
      const res = await axios.post("https://matrimony.bugchat.in/api/otpverify", {
        otp,
        clintid: clientId,
        aadhaar:aadhaarNumber,
        apikey,
      });
      console.log(res.data)
       
        
      if(res.data.data.code === 200){
        setAadhaarDigits(Array(12).fill(""));
        setOtpPopup(false)
        setClientId('')
         const profileData = res.data.data.data;
         const username =res.data.username
         const password = res.data.cpassword
         console.log(res.data.data)
      //  setData(res.data.data.data)
        navigate("/addprofiledata", {
  state: {
    profileData,
    aadhaar: aadhaarNumber,
    username,
    password
  },
});

      }
      console.log("OTP verified response:", res.data);

      // Optionally, redirect or show success
      // navigate("/profile");
    } catch (err) {
      console.error("Error verifying OTP:", err);
    }
  };

  return (
    <>
      <Header />
      <div className="entry-form-wrapper">
        <h2 className="entry-form-title">We Ask... Find Your Perfect Match!</h2>
        <div className="entry-form-container">
          <div style={{ flexShrink: 0, maxWidth: "300px", width: "100%" }}>
            <p className="entry-left-title">Bhantham</p>
            <img src="/images/gallery/matri.jpg" alt="Matrimony" className="entry-left-image" />
          </div>

          <div style={{ flex: 1, minWidth: "320px", width: "100%" }}>
            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <label style={{ fontWeight: "bold" }}>Enter Aadhaar Number</label>
              <div className="aadhaar-input-container">
                {aadhaarDigits.map((digit, index) => (
                  <input
                    key={index}
                    id={`aadhaar-box-${index}`}
                    type="text"
                    inputMode="numeric"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleAadhaarChange(index, e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace") {
                        const updatedDigits = [...aadhaarDigits];
                        if (aadhaarDigits[index] === "" && index > 0) {
                          updatedDigits[index - 1] = "";
                          setAadhaarDigits(updatedDigits);
                          const prevInput = document.getElementById(`aadhaar-box-${index - 1}`);
                          if (prevInput) prevInput.focus();
                        } else {
                          updatedDigits[index] = "";
                          setAadhaarDigits(updatedDigits);
                        }
                        e.preventDefault();
                      }
                    }}
                    className="aadhaar-box"
                  />
                ))}
              </div>

              {!otpPopup && (
                <button type="submit" className="register-btn">
                  <img
                    src="https://imgs.tamilmatrimony.com/bmimgs/homepage-revamp-images/register-free-icon.svg"
                    alt="Register Icon"
                    style={{ width: "22px", height: "22px" }}
                  />
                  REGISTER FREE
                </button>
              )}

              {otpPopup && (
                <>
                  <label style={{ fontWeight: "bold" }}>Enter OTP</label>
                  <div className="aadhaar-input-container">
                    {otpDigits.map((digit, index) => (
                      <input
                        key={index}
                        id={`otp-box-${index}`}
                        type="text"
                        inputMode="numeric"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Backspace") {
                            const updatedDigits = [...otpDigits];
                            if (otpDigits[index] === "" && index > 0) {
                              updatedDigits[index - 1] = "";
                              setOtpDigits(updatedDigits);
                              const prevInput = document.getElementById(`otp-box-${index - 1}`);
                              if (prevInput) prevInput.focus();
                            } else {
                              updatedDigits[index] = "";
                              setOtpDigits(updatedDigits);
                            }
                            e.preventDefault();
                          }
                        }}
                        className="aadhaar-box"
                      />
                    ))}
                  </div>
                  <button type="button" className="register-btn" onClick={handleVerifyOtp}>
                    <img
                      src="https://imgs.tamilmatrimony.com/bmimgs/homepage-revamp-images/register-free-icon.svg"
                      alt="Verify OTP"
                      style={{ width: "22px", height: "22px" }}
                    />
                    VERIFY OTP
                  </button>
                </>
              )}

              <div className="login-link">
                <p>
                  Already a member? <Link to="/login">Login</Link>
                </p>
              </div>
            </form>
          </div>

         
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Entryregister;
